import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _classCallCheck from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/createClass";
import { version } from '../package.json';

var LoginBase = /*#__PURE__*/function () {
  function LoginBase() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$source = _ref.source,
        source = _ref$source === void 0 ? '' : _ref$source;

    _classCallCheck(this, LoginBase);

    this._initialized = false;
    this._callbacks = [];
    this.VERSION = version;
    this._source = source;
  }
  /**
   * @param {function} callback
   * @returns {Promise}
   */


  _createClass(LoginBase, [{
    key: "init",
    value: function init(callback) {
      this.onInit(callback);
      return Promise.resolve();
    }
  }, {
    key: "ready",
    value: function ready() {
      this._callbacks.forEach(function (fn) {
        return fn();
      });

      this._callbacks = [];
      this._initialized = true;
    }
  }, {
    key: "onInit",
    value: function onInit(callback) {
      if (typeof callback === 'function') {
        if (this._initialized) {
          callback && callback();
        } else {
          this._callbacks.push(callback);
        }
      }
    }
  }, {
    key: "setConfig",
    value: function setConfig() {}
  }, {
    key: "isLogin",
    value: function isLogin() {}
  }, {
    key: "isStrictLogin",
    value: function isStrictLogin() {}
  }, {
    key: "isPTLogin",
    value: function isPTLogin() {}
  }, {
    key: "isQQLogin",
    value: function isQQLogin() {}
  }, {
    key: "isWXLogin",
    value: function isWXLogin() {}
  }, {
    key: "isNewQQLogin",
    value: function isNewQQLogin() {}
  }, {
    key: "loginType",
    value: function loginType() {}
  }, {
    key: "openLogin",
    value: function openLogin() {}
  }, {
    key: "logout",
    value: function logout() {}
  }, {
    key: "checkUser",
    value: function checkUser() {}
  }, {
    key: "getMainUserInfo",
    value: function getMainUserInfo() {}
  }, {
    key: "getMainCookie",
    value: function getMainCookie() {}
  }, {
    key: "getUin",
    value: function getUin() {}
  }, {
    key: "getUid",
    value: function getUid() {}
  }, {
    key: "getVuid",
    value: function getVuid() {}
  }, {
    key: "getToken",
    value: function getToken() {}
  }, {
    key: "loginSource",
    value: function loginSource() {
      return this._source;
    }
  }]);

  return LoginBase;
}();

export { LoginBase as default };